// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ShieldFilledIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="0 0 13 14">
    <path d="m6.5 0-6 2.55v3.81a8 8 0 0 0 6 7.64c3.44-.8 6-4.1 6-7.64V2.55l-3-1.28-.67 1.6 1 2.22L8.5 7.24v2.62l-.6-2.62.93-2.15L7.5 2.86l1-1.9z" />
  </svg>,
  "ShieldFilled",
);
export default ShieldFilledIcon;
